<template>
    <b-field :type="inputClass">
        <b-input
            v-model="answer"
            @input="onInput()"
        />
    </b-field>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, decimal } from 'vuelidate/lib/validators';

export default {
    mixins: [
        validationMixin,
    ],

    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            answer: '',
        };
    },

    computed: {
        fieldType: function () {
            return this.question.strFieldType.toLowerCase();
        },
        isFieldTypeNumeric: function () {
            const options = ['currency', 'number', 'integer', 'decimal'];
            return (options.indexOf(this.fieldType) === 0);
        },
        isValidationError: function () {
            return this.$v.$invalid;
        },
        inputClass: function () {
            return (this.answer.length && this.isValidationError ? 'is-danger' : '');
        },
    },

    validations() {
        var validations = {
            answer: {
                required,
            },
        };

        if (this.isFieldTypeNumeric) {
            validations.answer = {
                required,
                decimal,
            };
        };

        return validations;
    },

    methods: {
        onInput() {
            // emit event to update parent data, if there are no validation errors
            if(this.isValidationError) {
                this.$emit('input', '');
            } else {
                this.$emit('input', this.answer);
            }
        },
    },
};
</script>
